import PBIEmbed from './PBIEmbed';
export default PBIEmbed;
